import {CPSConstants} from "commonUtils/enumerations";

export const topBarStyle = {
  menuFont: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  imgStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    width: "1.2rem",
    marginRight: "0.75rem",
  },
};
